(() => {
  let queued = false;
  const start = () => {
    if (queued) return;
    queued = true;
    setTimeout(() => {
      [
      ].forEach(src => {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        document.head.appendChild(script);
      });
      /* Microsoft Clarity (moved out of Google Tag Manager, Nov 2026) */
      (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","c2k1mof9bl");
    }, 0);
  };
  if (document.readyState === 'complete') start();
  else {
    document.addEventListener('DOMContentLoaded', start, {once: true});
    window.addEventListener('load', start, {once: true});
  }
})();
